import {
  MANAGEMODULE_FETCH_LIST_LOADING,
  MANAGEMODULE_FETCH_LIST_SUCCESS,
  MANAGEMODULE_FETCH_LIST_FAILED,
  MANAGEMODULE_FETCH_FIRMWARE_LIST_LOADING,
  MANAGEMODULE_FETCH_FIRMWARE_LIST_SUCCESS,
  MANAGEMODULE_FETCH_FIRMWARE_LIST_FAILED,
  MANAGEMODULE_FETCH_TOOL_LIST_LOADING,
  MANAGEMODULE_FETCH_TOOL_LIST_SUCCESS,
  MANAGEMODULE_FETCH_TOOL_LIST_FAILED,
} from "../actions/manageModule";

const defVal = {
  // 模组列表加载loading
  moduleListLoading: false,
  // 模组列表
  moduleList: [],
  // 新增模组弹框
  moduleModalConfirmLoading: false,
  // 固件列表加载loading
  firmwareListLoading: false,
  // 固件列表
  firmwareList: [],
  // 固件列表总数
  firmwareListTotal: 0,
  // // 固件版本列表加载loading  固件版本列表信息已经在固件列表中返回，无需单独处理
  // firmwareVersionListLoading: false,
  // // 固件版本列表
  // firmwareVersionList: [],
  // 工具列表加载loading
  toolListLoading: false,
  // 工具列表
  toolList: [],
};

export default (state = defVal, action) => {
  switch (action.type) {
    case MANAGEMODULE_FETCH_LIST_LOADING:
      return Object.assign({}, state, {
        moduleListLoading: true,
      });
    case MANAGEMODULE_FETCH_LIST_SUCCESS:
      return Object.assign({}, state, {
        moduleListLoading: false,
        moduleList: action.moduleList,
        moduleListTotal: action.moduleListTotal,
      });
    case MANAGEMODULE_FETCH_LIST_FAILED:
      return Object.assign({}, state, {
        moduleListLoading: false,
      });

    case MANAGEMODULE_FETCH_FIRMWARE_LIST_LOADING:
      return Object.assign({}, state, {
        firmwareListLoading: true,
      });
    case MANAGEMODULE_FETCH_FIRMWARE_LIST_SUCCESS:
      return Object.assign({}, state, {
        firmwareListLoading: false,
        firmwareList: action.firmwareList,
        firmwareListTotal: action.firmwareListTotal,
      });
    case MANAGEMODULE_FETCH_FIRMWARE_LIST_FAILED:
      return Object.assign({}, state, {
        firmwareListLoading: false,
      });
    
    case MANAGEMODULE_FETCH_TOOL_LIST_LOADING:
      return Object.assign({}, state, {
        toolListLoading: true,
      });
    case MANAGEMODULE_FETCH_TOOL_LIST_SUCCESS:
      return Object.assign({}, state, {
        toolListLoading: false,
        toolList: action.toolList,
        toolListTotal: action.toolListTotal,
      });
    case MANAGEMODULE_FETCH_TOOL_LIST_FAILED:
      return Object.assign({}, state, {
        toolListLoading: false,
      });

    default:
      return state;
  }
};
